import { render, staticRenderFns } from "./SmallChart.vue?vue&type=template&id=3aa6c4e3&scoped=true&"
import script from "./SmallChart.vue?vue&type=script&lang=js&"
export * from "./SmallChart.vue?vue&type=script&lang=js&"
import style0 from "./SmallChart.vue?vue&type=style&index=0&id=3aa6c4e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6c4e3",
  null
  
)

export default component.exports